<template>
    <!-- Main footer container -->
    <div class="d-flex flex-column">
        <!-- Premium upgrade section -->
        <div
            v-if="upgradeButtonVisible"
            :class="[
                'd-flex flex-column align-items-center position-relative',
                { 'upgrade-cta': !isCompact },
            ]"
        >
            <!-- Close button -->
            <button
                v-if="!isCompact"
                class="close-icon-button position-absolute icon-btn icon-btn-white"
                @click="closeUpgrade"
                aria-label="Close upgrade prompt"
            >
                <i class="fi fi-x"></i>
            </button>

            <!-- Premium content -->
            <h3 v-if="!isCompact" class="m-0">Upgrade to Premium</h3>
            <p v-if="!isCompact" class="text-center m-0">
                Get 1 month free and <br />
                unlock more features
            </p>

            <!-- Upgrade button -->
            <button
                class="btn btn-secondary w-100 upgrade-button"
                @click="$emit('upgrade')"
            >
                <span>Upgrade</span>
                <i v-if="!isCompact" class="fi fi-add"></i>
            </button>
        </div>

        <!-- Action buttons -->
        <div class="row gx-0" style="gap: var(--space-2)">
            <button class="btn btn-light col" @click="provideFeedback">
                <span class="button-span" v-if="!isCompact"
                    >Provide Feedback</span
                >
                <i v-if="isCompact" class="fi fi-chat"></i>
            </button>
        </div>

        <button class="btn btn-white col-12" @click="logout">
            <span v-if="!isCompact" class="button-span">Logout</span>
            <i class="fi fi-logout"></i>
        </button>
    </div>
</template>

<script>
export default {
    name: 'SideBarFooter',

    props: {
        isCompact: {
            type: Boolean,
            required: true,
            default: false,
        },
    },

    emits: ['upgrade', 'logout', 'feedback'],

    data() {
        return {
            upgradeButtonVisible: false, // TODO: re-enable after subscriptions configured
        };
    },

    methods: {
        /**
         * Handles closing the upgrade prompt
         */
        closeUpgrade() {
            this.upgradeButtonVisible = false;
        },

        logout() {
            this.$postData('auth/logout').then((response) => {
                if (response.success) {
                    // Clear stores and storage FIRST
                    this.$userStore.clear();

                    // Preserve feedback modal snooze keys when clearing localStorage
                    const feedbackKeys = [];
                    for (let i = 0; i < localStorage.length; i++) {
                        const key = localStorage.key(i);
                        if (
                            key &&
                            ((key.startsWith('feedback_modal_last_shown') &&
                                key.endsWith('_snooze')) ||
                                key.startsWith('regions:company'))
                        ) {
                            feedbackKeys.push({
                                key: key,
                                value: localStorage.getItem(key),
                            });
                        }
                    }

                    localStorage.clear();

                    // Restore feedback modal keys after clearing
                    feedbackKeys.forEach(({ key, value }) => {
                        localStorage.setItem(key, value);
                    });

                    // THEN navigate to login
                    this.$router.push({ name: 'Login' });
                } else if ('message' in response && response.message) {
                    this.$alertStore.pushError(response.message);
                }
            });
        },

        provideFeedback() {
            this.$emit('feedback');
        },
    },
};
</script>

<style scoped>
/* Keeping existing CSS unchanged as requested */
.upgrade-cta {
    box-sizing: border-box;
    padding: var(--space-6) var(--space-4);
    gap: var(--space-3);
    background: linear-gradient(180deg, #eef6ef 0%, #ffffff 100%);
    border: 1px solid var(--neutral-500);
    border-radius: 8px;
    transition: width 0.3s ease-in-out, height 0.3s ease-in-out;
}

.upgrade-cta h3 {
    font-family: Inter;
    font-weight: 600;
    font-size: 16px;
    line-height: 18px;
    color: var(--black);
}

.upgrade-cta p {
    font-size: 14px;
    line-height: 24px;
    color: var(--neutral-800);
}

.upgrade-cta h3,
.upgrade-cta p,
.upgrade-cta button.upgrade-button {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
}

button i {
    font-size: 18px;
}

.upgrade-button {
    padding: 11px 15px;
    gap: 10px;
}

.upgrade-button span {
    font-size: 15px;
    line-height: 18px;
    height: 18px;
}

.button-span {
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    white-space: nowrap;
    overflow: hidden;
    max-width: 100%;
}

.close-icon-button {
    right: -8px;
    top: -6px;
    z-index: 3;
}

button {
    transition: width 0.3s ease-in-out;
}

@media only screen and (max-width: 767.98px) {
    .close-icon-button {
        left: 178px;
    }

    .upgrade-cta {
        padding: var(--space-5) var(--space-4);
    }

    .upgrade-cta h3 {
        font-size: 15px;
    }

    .upgrade-cta p {
        line-height: 20px;
    }
}
</style>
